import { studentConferencesConstants } from "../_constants";

export const studentConferencesActions = {
  load,
  reset,
};

function load(data) {
  return { type: studentConferencesConstants.LOAD, data };
}

function reset() {
  return { type: studentConferencesConstants.RESET };
}
